import React from 'react';
import TitleValueIcon from './titleValueIcon';
import TitleValue from './TitleValue';
import { type ITitleValue } from '../../../models/General';

export interface IInfoCardProps {
  label: string;
  icon?: string;
  details: ITitleValue[];
  extra?: React.ReactNode;
}
export const InfoCard: React.FC<IInfoCardProps> = ({
  label,
  icon,
  details,
  extra,
}: IInfoCardProps) => {
  return (
    <div className="infoCardContainer">
      <div className="infoCardDetailsContainer">
        <TitleValueIcon
          containerClassName="mb-4"
          title={label}
          icon={icon}
          value=""
        />
        {details.map((item) => {
          return (
            <TitleValue
              key={'profileDetail_' + item.title}
              title={item.title}
              value={item.value}
            />
          );
        })}
        {extra}
      </div>
    </div>
  );
};
